import { Box, Container, Grid2 } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../../commanComponents/LinearProgressBar";
import { String } from "../../../constants/Strings";
import { getColor } from "../../../style/color/color";
import ACRButton from "../../../commanComponents/ACRButton";
import {
  StyledACRButton,
  StyledButton,
  StyledContainer,
  StyledDivider,
  StyledQuestionTypography,
} from "../../../style/styleComponents/StyledFutureGoal";
import { useNavigate } from "react-router-dom";

import GoalSlider from "./GoalSlider";
import AgeSlider from "./AgeSlider";
import CustomSnackbar from "../../../commanComponents/CustomerSnackbar";
import { AuthContext } from "../../../Hooks/context/AuthContext";
import { DataContext } from "../../../Hooks/context/ChildData";
import { useSavingGoals } from "../../../api/apiEndpoints/SavingGoals";
import { useLocalStorage } from "../../../logic/LocalStorage/LocalStorage";
import { gaCustomEvent } from "../../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../../Hooks/context/OTPVeriryContext";

const InvestmentGoal = () => {
  const goalsButtons = [
    { name: String.Retirement.FutureGoal.buttomName.b1 },
    { name: String.Retirement.FutureGoal.buttomName.b2 },
    { name: String.Retirement.FutureGoal.buttomName.b3 },
    { name: String.Retirement.FutureGoal.buttomName.b4 },
    { name: String.Retirement.FutureGoal.buttomName.b5 },
  ];

  const [active, setActive] = useState(null);
  const [finaicalGoalMoney, setfinaicalGoalMoney] = useState("");
  const [years, setyears] = useState("");
  const [goalName, setGoalName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });

  const navigation = useNavigate();
  const { collectedData, collectData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { saveGoals } = useSavingGoals();
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { authTokens } = useContext(AuthContext);

  const { userId } = authTokens;

  //validation for inputs
  const validate = () => {
    let isValid = true;
    const newErrors = {
      goalName: "",
      finaicalGoalMoney: "",
      years: "",
    };

    if (!goalName) {
      newErrors.goalName = String.Retirement.SecondInning.selectGoal;
      isValid = false;
    }

    if (
      !finaicalGoalMoney ||
      isNaN(finaicalGoalMoney) ||
      finaicalGoalMoney <= 0
    ) {
      isValid = false;
    }

    if (!years || isNaN(years) || years <= 0) {
      isValid = false;
    }

    return isValid;
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage({ message, severity });
    setSnackbarOpen(true);
  };

  // Load previously saved data (if any)
  useEffect(() => {
    const retriveData = async () => {
      try {
        const data = await retrieveLocalFinancialData(
          `investmentgoal-${userId}`
        );

        if (data) {
          setfinaicalGoalMoney(data.finaicalGoalMoney);
          setyears(data.years);
          setGoalName(data.goalName);
          setActive(data.active);
        } else {
        }
      } catch (error) {}
    };
    retriveData();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle goal button click
  const onHandleClick = (index, goalName) => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioOtherFinancialGoals, verifyData.customerId);
    setActive(index);
    setGoalName(goalName);
  };

  // Save data and navigate
  const handleContineu = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioOtherFinancialGoalsContinue, verifyData.customerId);
    if (active === null) {
      showSnackbar(
        String.Retirement.FutureGoal.selectGoalerrorMessage,
        String.ErrorSeverity
      );
      return;
    }

    if (!validate()) {
      showSnackbar(
        String.Retirement.FutureGoal.goalAmountorNumberYear,
        String.ErrorSeverity
      );
    } else {
      collectData({
        ...collectedData,
        investment: { finaicalGoalMoney, years, goalName },
      });
      const goalData = {
        userId: userId,
        isParent: collectedData.isParent === undefined ? false : true,
        futureGoalName: goalName,
        requiredAmount: finaicalGoalMoney,
        targetYear: years,
        idealRetirement: collectedData.selectedCard
          ? collectedData.selectedCard
          : "",
        children: collectedData.children ? collectedData.children : [],
        dependants: collectedData.dependants ? collectedData.dependants : [],
        goals: [...(collectedData.selectedGoals || [])],
      };
      try {
        if (!userId && !goalData.isParent) {
          showSnackbar(String.errorMessageforGoalsave, String.ErrorSeverity);

          return;
        }
        saveLocalFinancialData(`investmentgoal-${userId}`, {
          finaicalGoalMoney,
          years,
          goalName,
          active,
        });
        const response = await saveGoals(goalData);

        if (response.httpCode === 200) {
          showSnackbar(
            String.successMessageforGoalsave,
            String.successSeverity
          );
          setTimeout(() => {
            navigation(String.navigations.fetchinfo);
          }, 3000);
        } else {
          showSnackbar(String.errorMessageforGoalsave, String.ErrorSeverity);
        }
      } catch (error) {
        showSnackbar(String.errorMessageforGoalsave, String.ErrorSeverity);
      }
    }
  };

  return (
    <StyledContainer
      sx={{
        height: "100vh",
      }}
    >
      <Container sx={{ flexGrow: 1 }}>
        <PageTitle PageTitle={String.Retirement.FutureGoal.Title} />
        <LinearProgressBar
          dragMessage={String.Retirement.FutureGoal.dragMessage}
          progress={48}
          progressNumber={48}
          stepNumber={2}
        />
      </Container>
      <Box sx={{ textAlign: "left" }}>
        <StyledQuestionTypography variant="body1">
          {String.Retirement.FutureGoal.question1}
        </StyledQuestionTypography>
        <Grid2
          container
          spacing={1}
          sx={{
            mt: 4,
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          {goalsButtons.slice(0, 3).map((goalButton, index) => (
            <Grid2
              item
              xs={4}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                pl: "10px",
                pr: "10px",
              }}
            >
              <StyledButton
                active={active === index}
                onClick={() => {
                  onHandleClick(index, goalButton.name);
                }}
              >
                {goalButton.name}
              </StyledButton>
            </Grid2>
          ))}
        </Grid2>
        <Grid2
          container
          spacing={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {goalsButtons.slice(3, 5).map((goalButton, index) => (
            <Grid2
              item
              xs={3}
              key={index + 3}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <StyledButton
                active={active === index + 3}
                onClick={() => {
                  onHandleClick(index + 3, goalButton.name);
                }}
              >
                {goalButton.name}
              </StyledButton>
            </Grid2>
          ))}
        </Grid2>
        <Box sx={{ mt: "10px" }}>
          {/* Diveder for seperation */}
          <StyledDivider />

          <GoalSlider
            question={String.Retirement.FutureGoal.question2}
            income={Number(finaicalGoalMoney)}
            setIncome={setfinaicalGoalMoney}
          />
          {/* Diveder for seperation */}
          <StyledDivider />

          <AgeSlider
            question={String.Retirement.FutureGoal.question3}
            onAgeChange={(value) => {
              setyears(value);
            }}
            totalAge={years}
            setIncome={setyears}
          />
        </Box>
      </Box>
      <StyledACRButton>
        <ACRButton
          label={String.continue}
          style={{
            width: "100%",
            maxWidth: "350px",
            backgroundColor: getColor.ColorButtonPrimarysurface,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "10px",
            mb: "20px",
            height: "60px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={handleContineu}
        />
      </StyledACRButton>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        severity={snackbarmessage.severity}
        message={snackbarmessage.message}
      />
    </StyledContainer>
  );
};

export default InvestmentGoal;
